// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606081033/js/" + chunkId + "." + {"44":"4cc0a3e3","225":"c871eb34","481":"2f23fb4a","486":"2ef19e2e","770":"e74058c5"}[chunkId] + ".0.8925957793664592.chunk.js";
};